(function () {
	var documentSelection	= $(document)
	,menuTab							= documentSelection.find('#main-menu a')
	,homeTab							= documentSelection.find('#main-menu a:first')
	,headlineSelection		= $('#headline');

	$('.fade').addClass('in');
	homeTab.tab('show');

	menuTab.on('shown.bs.tab', function (e) {
		e.preventDefault();
		var tab				= $(this).attr('href');
		var headline	= $(tab).data('headline');

		headlineSelection.html(headline);
		console.log(e.target);
		console.log(e.relatedTarget);

	}).on('hide.bs.tab', function () {
		// Hide Events
	});

	documentSelection.tooltip({
		selector	: '[data-toggle="tooltip"]'
		,animation: true
		,trigger	: 'hover'
		,container: 'body'
	});

})();